import React, { useContext, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import AuthenticationModal from './AuthenticationModal';
import LoggedInButton from './LoggedInButton';
import SignInButton from './SignInButton';
import SignInToaster from './SignInToaster';
import SignInMenu from './SignInMenu';
import { SignInToasterContext } from '../../context/ModalContext';
import { DESKTOP_SIGN_IN_QUERY } from './operations';
import { renderDesktopSignInLoading, renderDesktopSignInContainer, useOpenAccountToasterAnalyticsEvent } from './helpers';
import { analytics } from '../../tools/analytics';

export default function DesktopSignIn() {
  const { openModal: openToaster } = useContext(SignInToasterContext);

  const { loading, data = {} } = useQuery(
    DESKTOP_SIGN_IN_QUERY,
    {
      context: { batch: true },
      fetchPolicy: 'cache-and-network',
      ssr: false,
    },
  );

  useEffect(() => {
    if (data && !loading) {
      analytics.user.setData(data);
    }
  }, [data, loading]);

  const { userState = {}, userInfo = {} } = data;
  const { isLoggedIn = false } = userState;
  const { isProfileComplete = false } = userInfo;

  const fireAnalyticsEvent = useOpenAccountToasterAnalyticsEvent(isLoggedIn, isProfileComplete);

  const handleClick = () => {
    fireAnalyticsEvent();
    openToaster();
  };

  if (loading) return renderDesktopSignInLoading();

  return renderDesktopSignInContainer(
    (
      <>
        {
          !isLoggedIn
            ? <SignInButton onClick={handleClick} />
            : <LoggedInButton onClick={handleClick} />
        }
        <AuthenticationModal />
        <SignInToaster>
          <SignInMenu isLoggedIn={isLoggedIn} />
        </SignInToaster>
      </>
    ),
  );
}
